import { Button, Table } from 'antd';
import moment from 'moment';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import DirectDiscountApi from '../../functions/api/booking/DirectDiscountApi';
import MyUtil from '../../functions/MyUtil';
import TableUtils from '../../functions/TableUtils';
import ButtonFormatter from './ButtonFormatter';
import ButtonShow from './ButtonShow';
import { dayOptions } from './constant';

class ListDirectDiscount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listDirectDiscount: [],
      redirectAdd: false,
      redirectAddRecurring: false,
      list: [],
      widthWindow: window.innerWidth,
    };
  }

  async componentDidMount() {
    var listDirectDiscount = await DirectDiscountApi.getAll();
    if (listDirectDiscount)
      this.setState({ listDirectDiscount: listDirectDiscount });
  }

  activeFormatter = (cell, row) => {
    return (
      <ButtonFormatter
        cell={cell}
        row={row}
        onChangeList={this.handleChangeList}
        list={this.state.listDirectDiscount}
      />
    );
  };

  convertNameDay = (day) => {
    const dayDiscount = JSON.parse(day);

    let label = [];

    for (let i = 0; i < dayDiscount.length; i++) {
      for (let j = 0; j < dayOptions.length; j++) {
        if (j === dayDiscount[i]) {
          label.push(dayOptions[j]);
        }
      }
    }

    return <span>{label.join(', ')}</span>;
  };

  timeAppliedFormatter = (cell, row) => {
    const dateActive = row.active_at;
    const dateExpire = row.expire_at;
    if (!dateActive || !dateExpire) {
      return <span>{this.convertNameDay(row.day_discount)}</span>;
    }

    return (
      <span>{`${moment(dateActive).format('DD/MM/YYYY')} - ${moment(
        dateExpire
      ).format('DD/MM/YYYY')}`}</span>
    );
  };

  discountValueFormatter = (cell, row) => {
    return (
      <span>
        {cell <= 100 ? `${cell} %` : `${MyUtil.currencyFormat(cell)} vnđ`}
      </span>
    );
  };

  maxValueFormatter = (cell, row) => {
    return (
      <span>
        {cell
          ? `${MyUtil.currencyFormat(cell)} vnđ`
          : `${MyUtil.currencyFormat(row.discount_value)} vnđ`}
      </span>
    );
  };

  vehicleModelFormatter = (cell, row) => {
    return <span>{cell ? MyUtil.makeTitle(cell) : 'Tất cả'}</span>;
  };

  vehiclePartnerFormatter = (cell, row) => {
    return <span>{cell ? cell : 'Tất cả'}</span>;
  };

  partnerFormatter = (cell, row) => {
    return <span>{cell ? cell : 'Tất cả'}</span>;
  };

  handleInsertButtonClick = () => {
    this.setState({ redirectAdd: true });
  };

  handleInsertButtonClickRecurring = () => {
    this.setState({ redirectAddRecurring: true });
  };

  handleChangeList = (list) => {
    this.setState({ listDirectDiscount: list });
  };

  buttonShow = (cell, row) => {
    return <ButtonShow cell={cell} row={row} />;
  };

  render() {
    const { listDirectDiscount } = this.state;

    const canAdd = MyUtil.hasPermission(this.props.match_parent.url, 'add');

    if (this.state.redirectAdd) {
      return <Redirect push to={`${this.props.match_parent.url}/add`} />;
    }
    if (this.state.redirectAddRecurring) {
      return (
        <Redirect push to={`${this.props.match_parent.url}/add-recurring`} />
      );
    }

    const columnDirectDiscounts = [
      {
        title: 'ID',
        dataIndex: 'id',
        key: 'id',
        fixed: 'left',
      },
      {
        title: 'Giá trị giảm',
        dataIndex: 'discount_value',
        key: 'discount_value',
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('discount_value'),
        render: this.discountValueFormatter,
      },
      {
        title: 'Giảm tối đa',
        dataIndex: 'max_value',
        key: 'max_value',
        ...TableUtils.getColumnSearchProps('max_value'),
        render: this.maxValueFormatter,
      },
      {
        title: 'Thành phố',
        dataIndex: 'city_name',
        key: 'city_name',
        ...TableUtils.getColumnSearchProps('city_name'),
      },
      {
        title: 'Dòng xe',
        dataIndex: 'vhc_slug',
        key: 'vhc_slug',
        render: this.vehicleModelFormatter,
      },
      {
        title: 'Đối tác',
        dataIndex: 'part_name',
        key: 'part_name',
        render: this.partnerFormatter,
      },
      {
        title: 'Xe của đối tác',
        dataIndex: 'vhc_part_name',
        key: 'vhc_part_name',
        render: this.vehiclePartnerFormatter,
      },
      {
        title: 'Thời gian áp dụng',
        render: this.timeAppliedFormatter,
      },
      {
        title: 'Chỉnh sửa',
        render: this.activeFormatter,
        fixed: 'right',
      },
    ];

    return (
      <>
        {canAdd && (
          <Button
            onClick={this.handleInsertButtonClick}
            type="primary"
            size="large"
            className="mb-3"
          >
            Thêm
          </Button>
        )}
        {canAdd && (
          <Button
            onClick={this.handleInsertButtonClickRecurring}
            className="ml-3"
            type="basic"
            size="large"
          >
            Thêm giảm giá định kì
          </Button>
        )}

        <Table
          rowKey="id"
          size="small"
          columns={columnDirectDiscounts}
          dataSource={listDirectDiscount}
          className="mt-3"
          scroll={{ x: 'max-content' }}
        />
      </>
    );
  }
}

export default ListDirectDiscount;
